import React from 'react'
import styles from './Form.module.scss'

interface FormProps {
  children: React.ReactNode
  onSubmit: (e: React.FormEvent) => void
  className?: never
}

export const Form: React.FC<FormProps> = ({ children, onSubmit }) => (
  <form className={styles.form} onSubmit={onSubmit}>
    {children}
  </form>
)
